import map from 'lodash/map'
import { OrderPaymentStatus, OrderStatus } from '@ztechapps/order.common'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

const orderStatuses = map(OrderStatus, (e) => {
  return e.value
})

const orderPaymentStatuses = map(OrderPaymentStatus, (e) => {
  return e.value
})

export const orderListFieldConfig: ListFieldConfig = {
  code: { name: 'code', displayName: 'Code', defaultOnSearch: true, size: 100, index: 0 },
  status: {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: orderStatuses,
    },
    size: 100,
    index: 1,
  },
  companyName: { name: 'by.company.name', displayName: 'Customer/Company', size: 250, index: 2 },

  createdAt: {
    name: 'createdAt',
    displayName: 'Order date',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
    size: 200,
    index: 3,
  },
  shippingDate: {
    name: 'shipping.date',
    displayName: 'Shipping date',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.dateTimeZone,
    size: 200,
    index: 4,
  },
  carrierServiceType: { name: 'shipping.rate.serviceType', displayName: 'Ship via', size: 100, index: 5 },
  netAmount: { name: 'net', size: 100, index: 6, type: ListFieldTypeEnum.number },
  paymentStatus: {
    name: 'paymentStatus',
    displayName: 'Payment status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: orderPaymentStatuses,
    },
    size: 150,
    index: 7,
  },
  remarks: { name: 'remarks', size: 300, index: 8 },

  contactName: { name: 'by.profile.name', displayName: 'Contact Name', size: 300, isVisible: false },
  contactEmail: { name: 'by.profile.email', displayName: 'Contact Email', isVisible: false },
  contactPhone: { name: 'by.phone', displayName: 'Contact Phone', isVisible: false },
  tags: { name: 'tags', excludeOnSort: true, size: 120, isVisible: false },
  summary: { name: 'summary', displayName: 'Summary', excludeOnSort: true, isVisible: false },
  customerPoNumber: { name: 'customerPoNumber', displayName: 'Customer PO #', isVisible: false },
  updatedAt: {
    name: 'updatedAt',
    displayName: 'Updated At',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.dateTimeZone,
    isVisible: false,
  },
  _id: { name: '_id', isVisible: false },
  qboId: {
    name: 'qboId',
    displayName: 'Has QBO',
    isVisible: false,
    excludeOnSearch: true,
    type: ListFieldTypeEnum.boolean,
  },

  trackingNumber: {
    name: 'shipping.packages.tracking_number',
    displayName: 'Tracking Number',
    isVisible: false,
    size: 200,
    type: ListFieldTypeEnum.objectArray,
  },
}

//we loop to all fields of orderListFieldConfig and change the size to 100, and isVisible to false
export const orderListFieldConfigForMobile = Object.keys(orderListFieldConfig).reduce((acc, key) => {
  //default isVisible only are keys [code, status, companyName, uploadAssets ]
  const onlyVisibleKeys = ['code', 'status', 'companyName', 'uploadAssets']
  acc[key] = {
    ...orderListFieldConfig[key],
    size: 100,
    isVisible: onlyVisibleKeys.includes(key),
  }
  return acc
}, {})
